import { Card } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { getAuctionsData } from "../CarMarketHeadlines/functions";

import { DataGrid } from "@/components/elements";
import { defaultCurrency } from "@/lib/currency/getCurrency";
import { useAdListingMarketCarTransactions } from "@/services/ad-listings/get-ad-listing-market-car-transactions";
import { useAuctionMarketCarTransactions } from "@/services/auctions/get-auction-market-car-transactions";

import type { Currency } from "@/types/currency";
import type { FC } from "react";

type Source = "auctions" | "ads";

type Props = {
  carId: string;
  years?: number;
  currency?: Currency;
  cols?: number | { base?: number; sm?: number; md?: number; lg?: number };
  source?: Source;
};

export const MarketEventAnalysis: FC<Props> = ({
  carId,
  years = 3,
  currency = defaultCurrency,
  cols = 4,
  source = "auctions",
}) => {
  const { t } = useTranslation();

  const { data: auctionAll } = useAuctionMarketCarTransactions({
    marketCarId: carId,
    page: 1,
    pageSize: 999999,
  });

  const { data: adsAll } = useAdListingMarketCarTransactions({
    marketCarId: carId,
    page: 1,
    pageSize: 999999,
  });

  const totalAuctions = auctionAll?.total ?? 0;
  const totalAds = adsAll?.total ?? 0;

  let transactionsForMetrics: any;

  if (source === "auctions") {
    transactionsForMetrics = auctionAll ?? { page: 1, page_size: 0, total: 0, results: [] };
  } else if (source === "ads") {
    transactionsForMetrics = adsAll ?? { page: 1, page_size: 0, total: 0, results: [] };
  } else {
    transactionsForMetrics = {
      page: 1,
      page_size: (auctionAll?.results?.length ?? 0) + (adsAll?.results?.length ?? 0),
      total: totalAuctions + totalAds,
      results: [...(auctionAll?.results ?? []), ...(adsAll?.results ?? [])],
    } as any;
  }

  const items = getAuctionsData(t, source, transactionsForMetrics, currency, years);

  return (
    <Card>
      <DataGrid itemSets={items} cols={cols} />
    </Card>
  );
};

export default MarketEventAnalysis;
